import {
  IconBell,
  IconBellGray,
  IconBinocularsGray,
  IconChainLink,
  IconChainLinkGray,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconShareGray,
  IconTagGray,
  IconTvocGray,
  IconWarning,
  IconWarningGray,
  IconZoneGray,
} from '@assets/images/icon';
import { rtlsSystem } from '@assets/images/solution';
import video from '@src/assets/images/solution/logisticsSafety/video/rtlsVideo.mp4';

import subVideo1 from '@src/assets/images/solution/logisticsSafety/video/sub/rtlsVideo1.mp4';
import subVideo2 from '@src/assets/images/solution/logisticsSafety/video/sub/rtlsVideo2.mp4';
import subVideo3 from '@src/assets/images/solution/logisticsSafety/video/sub/rtlsVideo3.mp4';
import subVideo4 from '@src/assets/images/solution/logisticsSafety/video/sub/rtlsVideo4.mp4';

export default {
  banner: {
    title: 'Quản lý an toàn cho nhân viên kho',
    desc: 'An toàn của người lao động là ưu tiên hàng đầu. Trong môi trường có độ rủi ro cao, việc không đảm bảo an toàn cho người lao động không chỉ gây ảnh hưởng đến năng suất mà còn có thể dẫn đến trách nhiệm pháp lý. Ngoài ra, một môi trường kho logistics an toàn đóng vai trò quan trọng trong việc xây dựng hình ảnh doanh nghiệp và củng cố niềm tin của các bên liên quan.',
  },

  video: {
    title: 'Bảo vệ an toàn cho nhân viên kho một cách hiệu quả hơn.',
    desc: 'Hệ thống hiển thị vị trí của nhân viên làm việc trong khu vực logistics theo thời gian thực. Nhờ đó, người quản lý có thể phát hiện sớm các tình huống nguy hiểm và phản ứng nhanh chóng khi có sự cố xảy ra.<br/>Ngoài ra, hệ thống còn hỗ trợ việc tuân thủ các quy định an toàn và góp phần xây dựng lòng tin giữa nhân viên và người quản lý.',
    play: video,
  },

  func: [
    {
      title: 'Theo dõi vị trí thời gian thực',
      desc: 'Theo dõi vị trí của người lao động theo thời gian thực để giám sát tình hình an toàn, đồng thời hỗ trợ ứng phó nhanh chóng khi họ tiếp cận khu vực nguy hiểm hoặc khi có tình huống khẩn cấp xảy ra. Qua đó, chủ động phòng ngừa các rủi ro tiềm ẩn.',
      sub1: 'Độ chính xác cao',
      icon1: IconRulerGray,
      sub2: 'Kết nối dữ liệu nhanh chóng',
      icon2: IconShareGray,
      video: subVideo1,
    },
    {
      title: 'Theo dõi vị trí thiết bị nặng theo thời gian thực',
      desc: 'Không chỉ con người cần chú ý đến vấn đề an toàn. Việc xác định vị trí theo thời gian thực của các thiết bị nặng có nguy cơ gây tai nạn tiềm ẩn giúp phát hiện các trường hợp người lao động đến quá gần hoặc đi vào đường không an toàn, từ đó phòng ngừa tai nạn.',
      sub1: 'Chỉ định đối tượng nguy hiểm',
      icon1: IconWarningGray,
      sub2: 'Theo dõi vị trí thời gian thực',
      icon2: IconBinocularsGray,
      video: subVideo2,
    },
    {
      title: 'Phân tích lộ trình di chuyển của người lao động',
      desc: 'Nếu trên lộ trình di chuyển của người lao động có thiết bị hoặc vật liệu nguy hiểm, hệ thống có thể cảnh báo cho người quản lý. Nhờ đó, việc ứng phó hoặc cứu hộ kịp thời trở nên khả thi.',
      sub1: 'Lưu trữ dữ liệu trên nền tảng đám mây',
      icon1: IconCloudCheckGray,
      sub2: 'Cung cấp dữ liệu thống kê',
      icon2: IconChartBarGray,
      video: subVideo3,
    },
    {
      title: 'Thiết lập khu vực an toàn',
      desc: 'Bằng cách thiết lập trước các khu vực cấm tiếp cận hoặc khu vực cần chú ý đặc biệt tại hiện trường, hệ thống có thể cảnh báo cho người lao động đi qua gần đó hoặc gửi thông báo cho người quản lý. Nhờ đó, có thể phòng ngừa tai nạn.',
      sub1: 'Thiết lập phạm vi linh hoạt',
      icon1: IconZoneGray,
      sub2: 'Thiết lập nhiều khu vực',
      icon2: IconTagGray,
      video: subVideo4,
    },
  ],

  subfunc: {
    title: 'Tính năng đa dạng',
    desc: 'Đảm bảo an toàn cho người lao động giúp nâng cao hiệu quả công việc và giảm thiểu thiệt hại do tai nạn. Orbro đã xây dựng các tính năng tối ưu để bảo vệ an toàn cho người lao động trong ngành logistics.<br/>Hệ thống được thiết kế để ứng phó phù hợp với các sự cố an toàn có thể xảy ra, bao gồm khi người lao động tiếp cận khu vực nguy hiểm, khi tai nạn xảy ra, hoặc các tình huống nguy hiểm tiềm ẩn liên quan đến thiết bị nặng.',
    data: [
      {
        icon: IconChartRadius,
        title: 'Báo cáo và phân tích',
        desc: 'Có thể tạo báo cáo và tài liệu phân tích dựa trên dữ liệu thu thập từ công trường.',
      },
      {
        icon: IconBell,
        title: 'Cảnh báo theo thời gian thực',
        desc: 'Khi xảy ra tình huống bất thường cho người lao động hệ thống sẽ gửi cảnh báo để có thể ứng phó kịp thời.',
      },
      {
        icon: IconRoute,
        title: 'Truy xuất lịch sử di chuyển',
        desc: 'Có thể truy xuất lộ trình di chuyển của người lao động và chuyển thành dữ liệu.',
      },
      {
        icon: IconDashboard,
        title: 'Nắm bắt hiện trạng',
        desc: 'Xác định người lao động đang di chuyển đến đâu',
      },
      {
        icon: IconWarning,
        title: 'Phát hiện rời khỏi khu vực',
        desc: 'Hệ thống phát hiện khi người lao động rời khỏi khu vực làm việc hoặc di chuyển đến vị trí không đúng quy định.',
      },
      {
        icon: IconSearch,
        title: 'Phân tích mô hình lộ trình di chuyển',
        desc: 'Có thể chỉ định công việc tiếp theo dựa trên vị trí của người lao động',
      },
      {
        icon: IconChainLink,
        title: 'Tích hợp dữ liệu',
        desc: 'Kết nối hiệu quả với các hệ thống như RFID, IoT, an ninh và camera.',
      },
      {
        icon: IconSecurity,
        title: 'Bảo mật dữ liệu',
        desc: 'Duy trì mức độ bảo mật dữ liệu cao, đảm bảo cung cấp giải pháp có độ tin cậy vượt trội.',
      },
    ],
  },

  system: {
    title: 'Cấu trúc hệ thống',
    img: rtlsSystem,
  },

  productTitle: 'Cấu hình sản phẩm',
  product: [{ tag: 'assetPackage' }, { tag: 'workerPackage' }],

  contents: [{ data: 'logisticsAsset' }, { data: 'constructionSafety' }, { data: 'blogForklift' }, { data: 'blogRTLS' }],
};
